import { Permissions } from "atoms/auth";
import { atom } from "recoil";
import { AuthService } from "@adfenix/types";

export interface RoleWithPermissionsProps
  extends Omit<AuthService.RoleDto, "permissions"> {
  permissions: Permissions;
}

export const getDefaultPermissions = (): Permissions => ({
  Campaign: [],
  Listing: [],
  Reports: [],
  UserDomain: [],
  UserManagement: [],
  Admin: [],
  RoleManagement: [],
  ExternalApi: [],
  SelfServe: [],
  Program: [],
  ProgramAdmin: [],
  BillingReports: [],
  DatabaseBuilder: [],
  Agent: [],
  Budget: []
});

export const userSelectedRoleAtom = atom<RoleWithPermissionsProps>({
  default: {
    id: "",
    authenticationRequired: false,
    name: "Seller",
    accessLevel: "Property",
    permissions: getDefaultPermissions()
  },
  key: "userSelectedRoleAtom"
});
